import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as Wallet from '../../../wallet/api';
export const getRaces = createAsyncThunk('races/upcomingEvents', async (filter) => {
    try {
        return await Wallet.getRaces(filter);
    }
    catch (err) {
        return err.response;
    }
});
export const getRaceById = createAsyncThunk('race/id', async (id) => {
    try {
        return await Wallet.getRaceInfo(id);
    }
    catch (err) {
        return err.response;
    }
});
const clearData = (state) => {
    state.pending = false;
    state.error = null;
    state.races = [];
    state.race = null;
    state.filtersValue = null;
    state.horsesInRaces = [];
};
export const initialState = {
    pending: false,
    error: null,
    races: [],
    race: null,
    filtersValue: null,
    horsesInRaces: []
};
export const raceSlice = createSlice({
    name: 'race',
    initialState,
    reducers: {
        saveFilterData: (state, action) => {
            state.filtersValue = action.payload;
        },
        clearUpcomingRacesData: (state) => {
            clearData(state);
        },
        addHorseToRace: (state, action) => {
            state.horsesInRaces = [...state.horsesInRaces, action.payload];
        },
        removeHorseFromRace: (state, action) => {
            state.horsesInRaces = state.horsesInRaces.filter((it) => it.raceId !== action.payload);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getRaces.pending, (state) => {
            state.pending = true;
        });
        builder.addCase(getRaces.fulfilled, (state, action) => {
            state.pending = false;
            state.races = action.payload;
        });
        builder.addCase(getRaces.rejected, (state, action) => {
            state.pending = false;
        });
        builder.addCase(getRaceById.fulfilled, (state, action) => {
            state.pending = false;
            state.race = action.payload;
        });
    }
});
export const { saveFilterData, clearUpcomingRacesData, addHorseToRace, removeHorseFromRace } = raceSlice.actions;
export default raceSlice.reducer;
